import type { FormError } from '@nuxt/ui'

export class ForbiddenException extends Error {}

export class MFARequiredException extends Error {}

export class MFANotSetupException extends Error {}

export class InvalidTOTPCodeException extends Error {}

export class ThrottledException extends Error {}

export class UnauthenticatedException extends Error {}

export class NotFoundException extends Error {}

export class BadReqeustException extends Error {}

export class ValidationException extends Error {
  errors: Record<string, string>
  constructor(errors: Record<string, string>) {
    super('validation error')
    this.errors = errors
  }

  mapErrors(name: string): string {
    switch (name) {
      case 'required':
        return 'This field is requried'
      case 'gte':
        return 'This field has not met the minumum length requirement'
      case 'ip_addresses':
        return 'This field must only contain valid IP addresses'
      case 'send_at':
        return 'This value must be in the future'
      case 'email':
        return 'This value must be a valid email address'
      case 'invalid_template':
        return 'The template is not valid'
      case 'failed_template':
        return 'The template failed to execute, ensure all contacts have valid data or use conditionals in the template'
      case 'destinations':
        return 'Invalid destination numbers'
      case 'destination':
        return 'Invalid destination number'
      case 'country_id':
      case 'country':
        return 'Invalid country id'
      case 'provider':
        return 'Invalid provider'
      default:
        return name
    }
  }

  formErrors(): FormError[] {
    const out: FormError[] = []
    for (const key in this.errors) {
      out.push({
        name: key,
        message: this.mapErrors(this.errors[key] as string),
      })
    }
    return out
  }
}
